import type { TemplateVersion } from "../../../queries";

export function VersionDiff({ current, compare }: { current: TemplateVersion | null; compare: TemplateVersion | null }) {
  if (!current || !compare) {
    return <div className="text-sm text-slate-500">Select a previous version to compare.</div>;
  }

  return (
    <div className="grid gap-3 md:grid-cols-2">
      <DiffPane title={`Current v${current.version}`} body={current.body} />
      <DiffPane title={`Version v${compare.version}`} body={compare.body} />
    </div>
  );
}

function DiffPane({ title, body }: { title: string; body: string }) {
  return (
    <div className="rounded-md border border-slate-200">
      <div className="border-b border-slate-100 px-3 py-2 text-xs font-semibold text-slate-600">{title}</div>
      <pre className="max-h-56 overflow-auto whitespace-pre-wrap p-3 text-xs leading-relaxed text-slate-700">{body}</pre>
    </div>
  );
}
